import React, { useState, useEffect } from 'react';
import { Search, ChevronRight, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const CategoryManagement = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterType, setFilterType] = useState('');

    useEffect(() => {
        fetchCategories();
    }, [filterType]);

    const fetchCategories = async () => {
        setLoading(true);
        try {
            let url = '/categories';
            if (filterType) {
                url = `/categories/type/${filterType}`;
            }
            const response = await api.get(url);
            setCategories(response.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="category-management">
            <div className="filters-bar">
                <div className="search-input-wrapper">
                    <Search className="search-icon" size={20} />
                    <input
                        type="text"
                        placeholder="Tìm kiếm"
                        className="search-input"
                    />
                </div>
                <select
                    className="filter-select"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                >
                    <option value="">Tất cả loại</option>
                    <option value="JOB_FIELD">Lĩnh vực</option>
                    <option value="LOCATION">Địa điểm</option>
                    <option value="JOB_TYPE">Hình thức làm việc</option>
                    <option value="POSITION">Vị trí</option>
                    <option value="EDUCATION">Trình độ học vấn</option>
                    <option value="EXPERIENCE">Kinh nghiệm</option>
                </select>
                <button className="btn-primary" onClick={() => navigate('/categories/create')}>
                    Tạo danh mục mới
                </button>
            </div>

            <div className="data-table-container">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>Tên danh mục</th>
                                <th>Mã</th>
                                <th>Loại</th>
                                <th>Trạng thái</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((category, index) => (
                                <tr key={category.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <div style={{ fontWeight: 500 }}>{category.name}</div>
                                    </td>
                                    <td>{category.code}</td>
                                    <td>{category.type}</td>
                                    <td>
                                        {category.status ? 'Hoạt động' : 'Không hoạt động'}
                                    </td>
                                    <td>
                                        <button
                                            className="action-link"
                                            onClick={() => navigate(`/categories/${category.id}`)}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                        >
                                            Chi tiết <ChevronRight size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default CategoryManagement;
